const PrevNext = (props) => {

    const {
        currentIndex,
        setCurrentIndex,
        totalSlides,
    } = props;


    const prevButton = () => {
        setCurrentIndex((currentIndex - 1 + totalSlides) % (totalSlides));
    }
    const nextButton = () => {
        setCurrentIndex((currentIndex + 1) % (totalSlides));
    }

  return (
    <>
        <button className='prev-next__prev' onClick={prevButton}/>
        <button className='prev-next__next' onClick={nextButton}/>
    </>
  )
}

export default PrevNext